/**
 * Field-only updates for the PIF "I don't have an email address" checkbox.
 * Never replace local formData / collection rows from a full PIF snapshot —
 * that wipes in-progress traveler fields.
 */

/**
 * @param {{ formData: Record<string, unknown>, askedIfSamePerson: boolean }} ui
 * @param {boolean} doesNotOwnEmail
 * @returns {{ does_not_own_email: unknown, email: unknown, askedIfSamePerson: boolean }}
 */
export function applyOptimisticDoesNotOwnEmailToggle(ui, doesNotOwnEmail) {
  const snapshot = {
    does_not_own_email: ui.formData.does_not_own_email,
    email: ui.formData.email,
    askedIfSamePerson: ui.askedIfSamePerson
  }
  ui.formData.does_not_own_email = doesNotOwnEmail
  if (doesNotOwnEmail) {
    ui.formData.email = null
  }
  if (!doesNotOwnEmail) {
    ui.askedIfSamePerson = false
  }
  return snapshot
}

/**
 * @param {{ formData: Record<string, unknown>, doesNotOwnEmail: boolean, askedIfSamePerson: boolean }} ui
 * @param {{ does_not_own_email: unknown, email: unknown, askedIfSamePerson: boolean }} snapshot
 */
export function revertDoesNotOwnEmailToggle(ui, snapshot) {
  ui.formData.does_not_own_email = snapshot.does_not_own_email
  ui.formData.email = snapshot.email
  ui.doesNotOwnEmail = !!snapshot.does_not_own_email
  ui.askedIfSamePerson = snapshot.askedIfSamePerson
}

/**
 * Keep existing collection fields; copy only email ownership from the API row.
 *
 * @param {Array<Record<string, unknown>>} collection
 * @param {Record<string, unknown>|null|undefined} resource
 * @returns {Array<Record<string, unknown>>}
 */
export function patchCollectionDoesNotOwnEmailFields(collection, resource) {
  if (!resource || resource.id == null) {
    return collection
  }
  const list = collection || []
  const index = list.findIndex(item => item.id === resource.id)
  if (index === -1) {
    return list.concat([resource])
  }
  const next = list.slice()
  next[index] = {
    ...list[index],
    does_not_own_email: resource.does_not_own_email,
    email: resource.email
  }
  return next
}
